import React, { useState, useEffect } from 'react';
import {
    Table,
    Button,
    Space,
    Modal,
    message,
    Input,
    Switch,
    Form,
} from 'antd';
import useWebPost from '../../utils/useWebPost';

function AppConfig() {
    const webPost = useWebPost(); // 直接使用你的钩子
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();

    useEffect(() => {
        fetchList();
    }, []);

    const fetchList = async () => {
        setLoading(true);
        try {
            const response = await webPost('appc', {});
            if (response) {
                const nums = response.nums || '';
                const numArray = nums.split('|')
                    .filter(item => item.trim() !== '')
                    .concat(new Array(15).fill('0'));
                const numObj = {};
                for (let i = 0; i < 15; i++) {
                    numObj[`ns${i + 1}`] = numArray[i];
                }
                form.setFieldsValue({ ...response, ...numObj });
            }
        } catch (error) {
            console.error('获取列表失败:', error);
            message.error('请求失败，请稍后重试');
        } finally {
            setLoading(false);
        }
    };

    return (

        <Form
            style={{ width: 'calc(100% - 50px)', maxHeight: 'calc(100vh - 60px)', overflow: 'hidden', overflowY: 'auto', background: "#fff", padding: '24px' }}
            form={form}
            loading={loading}
            onFinish={async (values) => {
                try {
                    const numString = Array.from({ length: 15 }, (_, i) => {
                        const val = values[`ns${i + 1}`];
                        return Number(val)>0 ? val: 0;
                    }).join('|');
                    const response = await webPost('appcSave', {
                        ...values, nums: numString
                    });
                    if (response) {
                        message.success(`更新成功`);
                    }
                } catch {
                    message.error(`更新失败`);
                }
            }}
            layout="vertical"
        >
            <div style={{ marginBottom: 20, paddingBottom: 10, borderBottom: '1px solid #e8e8e8' }}>
                <h4 style={{ margin: '0 0 10 0', color: 'green' }}>资信管理预警设置</h4>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16 }}>
                    <Form.Item
                        label="企业资质审核提前预警天数"
                        name="num1"
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="员工资质审核提前预警天数"
                        name="num2"
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="证书使用可使用预警天数"
                        name="num3"
                    >
                        <Input />
                    </Form.Item>
                </div>
            </div>
            <div style={{ marginBottom: 20, paddingBottom: 10, borderBottom: '1px solid #e8e8e8' }}>
                <h4 style={{ margin: '0 0 10 0', color: 'green' }}>账号网络部管理预警设置</h4>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16 }}>
                    <Form.Item
                        label="财务账号提前预警天数"
                        name="num4"
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="公司内部账号预警天数"
                        name="num5"
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="合作单位账号预警天数"
                        name="num6"
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="特种作业账号预警天数"
                        name="num7"
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="办公用账号预警天数"
                        name="num9"
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="其它账号预警天数"
                        name="num8"
                    >
                        <Input />
                    </Form.Item>
                </div>
            </div>
            <div style={{ marginBottom: 20, paddingBottom: 10, borderBottom: '1px solid #e8e8e8' }}>
                <h4 style={{ margin: '0 0 10 0', color: 'green' }}>合同管理预警设置</h4>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16 }}>
                    <Form.Item
                        label="投标保证金预警"
                        name="ns1"
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="质保金预警"
                        name="ns2"
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="合同履约预警"
                        name="ns3"
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="工期预警"
                        name="ns4"
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="财务数据预警"
                        name="ns5"
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="竣工验收预警"
                        name="ns6"
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="合同关闭预警"
                        name="ns7"
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="项目余额预警"
                        name="ns8"
                    >
                        <Input />
                    </Form.Item>
                </div>
            </div>
            <div style={{ marginBottom: 20, paddingBottom: 10, borderBottom: '1px solid #e8e8e8' }}>
                <h4 style={{ margin: '0 0 10 0' }}>客户信息选项设置</h4>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16 }}>
                    <Form.Item
                        label="合同保险日天数"
                        name="num10"
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="投标日期天数"
                        name="num11"
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="合同类型"
                        name="str1"
                        extra="《客户信息》中的合同类型"
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="业主性质"
                        name="str2"
                        extra="《客户信息》中的业主性质"
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="所属行业"
                        name="str3"
                        extra="《客户信息》中的所属行业/专业"
                    >
                        <Input />
                    </Form.Item>
                </div>
            </div>


            <Form.Item style={{ textAlign: 'right' }}>
                <Space>
                    <Button type="primary" htmlType="submit" loading={loading}>
                        保存
                    </Button>
                </Space>
            </Form.Item>
        </Form>
    );
}

export default AppConfig;